import http from "../http-common";

class MajorDescService {
  createMajorDesc(data) {
    return http.post(`/api/major_desc`, data);
  }
  getMajorsDesc() {
    return http.get(`/api/major_desc`);
  }
 getMajorDescByFilter(data){
  console.log(data);
  
     return http.get(`/api/major_desc/getMajorDescByFilter?section=`+data.section+'&&group_m='+data.group_m+'&&number='+data.number+'&&credit='+data.credit);
   }
  updateMajorDesc(id, data) {
    return http.put(`/api/major_desc/${id}`, data);
  }
}

export default new MajorDescService();